<template>
  <div id="app">
    <Spin fix type="larget" style="z-index: 100000" v-if="loading" />
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      loading: state => state.loading.loading,
    })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.ivu-tabs-tab-active {
  /*color:  #D2995B !important;*/
  /* 004800 */
  color: #004800 !important;
  font-weight: 600;
}
.ivu-tabs-ink-bar {
  background-color: #004800 !important;
}
.ivu-menu {
  font-weight: 600;
}
.ivu-menu-item-active {
  color:  #004800 !important;
  font-weight: 600;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active{
  border-bottom: 2px solid #004800 !important;
}

.ivu-btn-primary {
  color: #fff;
  font-weight: 500;
  background-color: #004800;
  border-color: #004800;
}
.ivu-btn-ghost.ivu-btn-primary {
  color: #ffffff;
  font-weight: 500;
}
/*.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover
{
  color: #2d8cf0;
  border-bottom: 2px solid #2d8cf0;
}
*/

</style>
